export const basicSweetAlert=[
    {
        text:"Print the basic message."
    }
]

export const titleSweetAlert=[
    {
        text:"Print the title with text."
    }
]

export const infoSweetAlert=[
    {
        text:"Print the informational message."
    }
]

export const warningSweetAlert=[
    {
        text:"Warning for imaginary files."
    }
]

export const pikachuAlertData=[
    {
        text:"catch the pokeball."
    }
]

export const questionAlertData=[
    {
        text:"Print the questionary and give answers."
    }
]

export const usernameAlertData=[
    {
        text:"Print the basic sweet-alert"
    }
]

export const successMassageData=[
    {
        text:"Print the success message."
    }
]

export const dangerMessageData=[
    {
        text:"Print the danger message."
    }
]

export const warningModeData=[
    {
        text:"Print the warning message."
    }
]

export const autoCloseData=[
    {
        text:"A text message with an automatic timer"
    }
]


export const ajaxData=[
    {
        text:"Give the movie name & return value."
    }
]